import PlanoService from '@/src/services/planos'

const planoMixin = {
    data() {
        return {
            planosFields: [
                {
                  key: 'descricao',
                  label: 'Planos',
                  class: 'size-col-20',
                  field: 'descricao'
                },
                {
                  key: 'valorMensalidadeTitular',
                  label: 'Valor titular',
                  class: 'size-col-20',
                  field: 'valorMensalidadeTitular'
                },
                {
                    key: 'valorMensalidadeDependente',
                    label: 'Valor Dependente',
                    class: 'size-col-20',
                    field: 'valorMensalidadeDependente'
                  },
                { key: 'actions', label: '', class: 'size-col-10' },
              ]
        }
    },
    methods: {
        async registerPlano(plano) {
            await PlanoService.create(plano)
        },
        loadPlanos() {
            let planos = [];

            return PlanoService.list().then(response => {
                response.data.map(plano => planos.push(plano._doc))
                return planos
              });
        },
        async editPlano(id, plano) {
            await PlanoService.update(id, plano)
        },
        async deletePlano(id) {
            await PlanoService.remove(id)
        }
    }
}

export default planoMixin